import { fromJS } from 'immutable';
import { ROUTES } from '@shared/constants';
import { Types } from './actions';

export const initialState = fromJS({
  values: {
    email: '',
  },
  errors: {
    serverError: null,
  },
  sending: false,
  redirectToPage: null,
  codeDeliveryDetails: null,
});

const passwordReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case Types.SEND_PASSWORD_LINK: {
      return state
        .setIn(['values'], fromJS({ ...payload }))
        .setIn(['errors', 'serverError'], null)
        .setIn(['redirectToPage'], null)
        .set('codeDeliveryDetails', null);
    }

    case Types.SEND_PASSWORD_LINK_FAIL: {
      return state
        .setIn(['errors', 'serverError'], fromJS(payload.error))
        .setIn(['redirectToPage'], null)
        .set('codeDeliveryDetails', null);
    }

    case Types.SEND_PASSWORD_LINK_SUCCESS: {
      return state
        .setIn(['errors', 'serverError'], null)
        .set('codeDeliveryDetails', fromJS(payload?.codeDeliveryDetails || null))
        .setIn(['redirectToPage'], fromJS(ROUTES.RESET_PASSWORD));
    }

    case Types.CLEAR_UI_STATE: {
      return state
        .setIn(['errors', 'serverError'], null)
        .setIn(['redirectToPage'], null)
        .set('codeDeliveryDetails', null);
    }

    default: {
      return state;
    }
  }
};

export default passwordReducer;
